import {Base, model, endpoint, belongsTo, getFrom} from '@scoutgg/ftw/source/lib/model'

@model('TablePosition')
@endpoint('table_positions', {root: '/api'})
@belongsTo('team')
@belongsTo('season')
@belongsTo('original', {className: 'TablePosition'})
@getFrom('team', [
  'name',
])
export class TablePosition extends Base {
  get diff() {
    return (this.goals || 0) - (this.against || 0)
  }

  toJSON() {
    const json = super.toJSON()
    if(json._id < 0) delete json._id
    if(this.original) json._id = this.original._id
    json.team = json.teamId
    delete json.teamId
    return json
  }
}
